module.exports = __webpack_public_path__ + "img/drawer-avatar.09cbd7ef.png";